import React from 'react'

import { Route, Switch } from 'react-router';

import App from './components/App';
import Browser from './scenes/Browser';
import Splash from './components/Splash';
import News from './scenes/News';
import Contacts from './scenes/Contacts';
import Login from './scenes/Login';
import Logout from './scenes/Logout';
import Registration from './scenes/Registration';
import Reset from './scenes/Reset';
import Profile from './scenes/Profile';
import Checkout from './scenes/Checkout';
import TOS from './scenes/TOS';
import Gallery from './scenes/Gallery'
// const redirectToLogin = (nextState, replace) => {
//   if (!loggedIn()) {
//     replace({
//       pathname: '/login',
//       state: { nextPathname: nextState.location.pathname }
//     });
//   }
// };

// const redirectToDashboard = (nextState, replace) => {
//   if (loggedIn()) {
//     replace('/');
//   }
// };


export default (
  <Switch>
    <App>
      <Route exact path="/" component={Splash} />
      <Route path="/browse/:id(\d+)?" component={Browser} />
      <Route path="/news" component={News} />
      <Route path="/registration" component={Registration} />
      <Route path="/gallery" component={Gallery}/>
      <Route path="/contacts" component={Contacts}/>
      <Route path="/login" component={Login} />
      <Route path="/logout" component={Logout} />
      <Route path="/reset" component={Reset} />
      <Route path="/profile" component={Profile} />
      <Route path="/checkout" component={Checkout} />
      <Route path="/tos" component={TOS} />
    </App>
  </Switch>
);



// WEBPACK FOOTER //
// ./src/routes.js